export default __webpack_public_path__ + "static/media/mlodz8.53d28904.jpg";